import { Button } from '@campgladiator/cgui-core.atoms.button'
import { Paragraph } from '@campgladiator/cgui-core.atoms.typography'

const BannerNotice = () => {
  const goToSubmitStatus = () => {
    const weightInput = document.getElementById('bodyWeight')
    if (weightInput) {
      weightInput.focus()
    }
  }

  return (
    <div className="banner-notice">
      <Paragraph className="banner-notice__content">
        Submit your stats to see your progress in the boxes below. Progress
        won't appear until you have submitted at least twice.
      </Paragraph>
      <Button
        solid
        secondary
        size="xsmall"
        onClick={goToSubmitStatus}
        className="banner-notice__submit-stats-btn"
      >
        submit stats
      </Button>
    </div>
  )
}

export default BannerNotice
